/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import authMgr from '@ion/applications/src/authentication/AuthenticationManager';
import {signoutCTC, signoutSSO} from '@/store/actions/login';
import {userSelector} from '@/store/selectors/login-selectors';

/**
 * @useLogout
 *
 * Provides a reusable hook which allows for automating the process of logout from app.
 *
 * ```typescript
 *
 *   import {useLogout} from './hooks/useLogout';
 *
 *   const onLogout = useLogout();
 *
 * ```
 *
 */
export const useLogout = () => {
  const dispatch = useDispatch();
  const user     = useSelector(userSelector);
  const provider = authMgr.hasIdProvider;
  const onLogout = useCallback(function() {
    dispatch(signoutCTC() as any);
  }, []);

  const onLogoutSSO = useCallback(function() {
    dispatch(signoutSSO(user?.username, provider) as any);
  }, []);

  if (authMgr.getIsOIDCEnabled()) {
    return onLogoutSSO;
  }
  return onLogout;
};
